import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VenderVehicleListRes;
export const VenderVehicleListTodo = createAsyncThunk('VenderVehicleList', async (data) => {
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL +  `admin_ven_vehicle_data/${'0'}`,
            params: {
                "fk_user_id": data
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VenderVehicleListRes = res.data

    } catch (error) {
        return VenderVehicleListRes = error.response.data
    }
})

const VenderVehicleListSlice = createSlice({
    name: 'VenderVehicleList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VenderVehicleListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VenderVehicleListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VenderVehicleListSlice.reducer; 